import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Trading from "./components/Trading/Trading";
import PayoutPool from "./components/PayoutPool/PayoutPool";
import Profile from "./components/Profile/Profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import FAQ from "./components/FAQ/FAQ";
import ProtectedRoute from "./ProtectedRoute";
import useAuthRedirect from "./hooks/useAuthRedirect";
import { UserProvider } from "./context/UserContext";
import Refer from "./components/Refer/Refer";
import PaymentCompleted from "./components/PurchaseOptions/PaymentCompleted";
import PaymentCancelled from "./components/PurchaseOptions/PaymentCancelled";
import DataEngine from "./components/DataEngine/DataEngine";
import LeaderboardContent from "./components/LeaderboardContent/LeaderboardContent";
import FlywheelStats from "./components/FlywheelStats/FlywheelStats";
import { MarketProvider } from "./context/MarketContext";
import Arena from "./components/Arena/Arena";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");

  const correctPassword = process.env.REACT_APP_PASSWORD;

  useAuthRedirect();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      setIsAuthenticated(true);
    } else {
      alert("Incorrect password. Please try again.");
    }
  };

  if (isAuthenticated) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f4f4f4",
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            style={{
              width: "100%",
              padding: "10px",
              margin: "10px 0",
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
          />
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#30970B",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </form>
      </div>
    );
  }
  return (
    <BrowserRouter>
      <ToastContainer />
      <MarketProvider>
        <UserProvider>
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/trading" element={<Trading />} />
              <Route path="/data-engine" element={<DataEngine />} />
              <Route path="/leaderboard" element={<LeaderboardContent />} />
              <Route path="/stats" element={<FlywheelStats />} />
              <Route path="/arena" element={<Arena />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/refer" element={<Refer />} />
              <Route path="/payment-complete" element={<PaymentCompleted />} />
              <Route path="purchase-cancel" element={<PaymentCancelled />} />
            </Route>
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </UserProvider>
      </MarketProvider>
    </BrowserRouter>
  );
}

export default App;
